const API_BASE_URL = (import.meta as { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL ?? 'http://localhost:5000/api';

function buildHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('rithmo_token') : null;
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

async function apiRequest(endpoint: string, options: RequestInit = {}): Promise<unknown> {
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      ...buildHeaders(),
      ...(options.headers as Record<string, string>),
    },
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => ({}))) as { message?: string };
    throw new Error(errorBody.message ?? `HTTP ${response.status}`);
  }

  return response.json();
}

export const agendaVoiceApi = {
  createSession: (meetingId?: string) =>
    apiRequest('/agendaVoice/session', {
      method: 'POST',
      body: JSON.stringify(meetingId ? { meetingId } : {}),
    }),
  sendTurn: (sessionId: string, userText: string, commitMeta: { commitMode: string; stepAtCommit: string }) =>
    apiRequest(`/agendaVoice/session/${sessionId}/turn`, {
      method: 'POST',
      body: JSON.stringify({ userText, commitMeta }),
    }),
  updateDraft: (
    sessionId: string,
    payload: {
      meetingMetadata?: { meetingTitle?: string; meetingDurationSec?: number | null; recurring?: boolean };
      agendaDraft?: Array<{ id: string; title?: string; plannedDurationSec?: number | null }>;
    }
  ) =>
    apiRequest(`/agendaVoice/session/${sessionId}/draft`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
  finalize: (sessionId: string) =>
    apiRequest(`/agendaVoice/session/${sessionId}/finalize`, {
      method: 'POST',
    }),
  listUpcoming: () => apiRequest('/agendaVoice/upcoming'),
};
